import app, { u_, vuwer } from "@@assets/scripts/common";

const dataKey = "posts";

// [listSection] VuwFade
vuwer.add("listSection", {
	vuwType: "fade",
	selector: "#list_section",
	
	async onChangeState(state) {
		if(state.update) {
			if(state.visible) {
				return this.get("dataList").setState("update", true);
			} else {
				// 非表示の場合は遅延実行とする
				setTimeout(() => {
					this.get("dataList").setState("update", true);
				}, this.delay);
			}
			
		}
	}
}, function() {
	// [add child Vuw]
	this
	// [dataList]
	.add("dataList", {
		vuwType: "colony",
		selector: "#data_list",
		
		// ** for TyrellModule **
		module: {
			app,
			dataKey,
			// 取得条件
			getFilter: {
				// // 取得項目（未指定や空の配列の場合は全て取得）
				// getParams: [],
				// // 除外項目
				// kickParams: [],
				// 取得条件 ※SQLのWHEREに相当
				// conditions: []
			},
/*
			// 一覧データの日付によるグループ分けのキー（年月ごとのグループ分け）※未指定の場合は"dateUpd"
			pkGroupByDate: "dateUpd",
			
			// 一覧データの日付によるグループ分けのフォーマット ※未指定の場合は"YYYY-MM"
			byDateFormat: "YYYY-MM",
			
			// データ配列のフィルタ処理用コールバック（return falseでそのデータを排除）
			itemFilter(i, item) {
			},
*/
			
			// 設定情報の上書き
			configOverride: {
				// NEWマークを付ける期間
				periodNew: app.now.subtract(2, "weeks")
			}
		},
		
		// ** for VuwColony **
		// 記事のテンプレートのセレクタ（未指定の場合は最後の子要素がテンプレートとなる）
		articleTemplate: "",
		
		// ページ情報のクエリ文字列
		pageQuery: "page",
		
		// ページャーの表示・非表示
		showPager: true,
		
		// ページャーから除外するクエリ文字列
		excludeQueryFromPager: ["post"],
		
		/*----------------
		* 記事表示用の関数（未指定の場合はテンプレートから生成）
		* @param item [object] １記事分のデータオブジェクト
		* @param config [object] 設定オブジェクト
		* @param $artcl [$] テンプレートから生成された$オブジェクト
		* @param module [TyrellModule] データ取得用モジュール
		* @return (falseを返すと非表示)
		*/
		initArticle(item, config, $article, module) {
			const qs = u_.createQueryString({
				post: item.itemId
			});
			
			// href
			$article.children("a").attr({
				href: `./${qs}`
			}).addClass("change-state");
			
			// NEW
			if(!config.periodNew.isAfter(item.dateIssue, "day")) {
				$article.addClass("is-new");
			}
		},
		
		onChangeState(state) {
			if(state.update) {
				return this.initList();
			}
		}
	}, function() {
		// appから直接アクセス可能にする
		const dataKey = this.module.getDataKey();
		app[dataKey] = this.module;
	});
});
